import { Account } from 'dashboard/models/account';
import { Selfie } from 'dashboard/models/selfie';
import AccountSelfiesSection from 'dashboard/views/DashboardAccountsShowView/components/AccountSelfiesSection';

interface SimilaritySelfieProps {
  account: Account;
  selfies: Selfie[];
}

const SimilaritySelfie = ({ account, selfies }: SimilaritySelfieProps) => {
  return <AccountSelfiesSection account={account} selfies={selfies} />;
};

export default SimilaritySelfie;
